<template>
  <div class="breadcrumbs-container d-flex align-center" v-if="parent != null">
    <v-col @click="previusRoute">
                <v-col class="backButton link-to-parent d-flex align-center">
                  <arrow-right :size="'4rem'" class="arrow" />
                  <span class="back-button-text">
                    {{ parent.title }}
                  </span>
                </v-col>
              </v-col>

    <!-- <router-link
      class="link-to-parent d-flex align-center"
      :to="`/page/${parent.urlKey}`"
    >
      <arrow-right :size="'4rem'" class="arrow" />
      {{ parent.title }}
    </router-link> -->
  </div>
</template>
<script>
import ArrowRight from '../_shared/svg/ArrowRight.vue'
export default {
  components: { ArrowRight },
  name: 'Breadcrumbs',
  data: () => ({
    parent: null
  }),
  methods: {
    fillBreadcrumbs() {
      this.parent = this.$store.getters.breadcrumbs
    },
    previusRoute() {
      if (document.location.hash !== '#/') {
        this.$router.go(-1)
      }
    }
  },
  watch: {
    breadcrumbsState: function () {
      this.fillBreadcrumbs()
    }
  },
  computed: {
    breadcrumbsState: function () {
      return this.$store.getters.breadcrumbs
    }
  }
}
</script>
<style lang="scss" >
.breadcrumbs-container {
  padding-left: $xl-indent;
  padding-right: $xl-indent;
  height: 6.4rem;
  .arrow {
    transform: rotate(180deg);
    margin-right: 1.5rem;
    cursor: pointer;
  }

  .v-breadcrumbs {
    padding-right: 0;
    padding-left: 0;
    display: inline-block;
  }

  a.link-to-parent {
    color: black;
    font-size: 1.8rem;
    font-weight: bold;
    text-decoration: none;
  }

  .back-button-text {
    color: black;
    font-size: 1.8rem;
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .breadcrumbs-container {
    padding-left: $xs-indent;
    padding-right: $xs-indent;
  }
}
</style>
